import { createSlice } from "@reduxjs/toolkit";
import { missionsApi } from "./missions.api";
// Api response type
const initialState = {
    missions: [],
    dictionary: {},
    config: {}
};
export const missionsSlice = createSlice({
    name: "missions",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addMatcher(missionsApi.endpoints.getMissions.matchFulfilled, (state, action) => {
            return Object.assign(Object.assign({}, state), action.payload);
        });
    }
});
//# sourceMappingURL=missions.slice.js.map